export default __webpack_public_path__ + "static/media/consent-video-thumbnail.f971d0ad.png";